<template>
  <div>
    <div class="header profile" />
    <div class="container">
      <div class="box is-large gutter">
        <h1 class="title is-1">
          Your custom order
        </h1>

        <div v-if="loaded === true">
          <div
            v-for="(item, i) in order.items"
            :key="`${i}-${item}`"
            class="columns is-mobile is-vcentered track"
          >
            <div
              class="column cover is-narrow is-hidden-mobile"
            >
              <img :src="tracks[item.track].cover_thumbnail">
            </div>
            <div class="column">
              <p class="text label-medium track-title">
                {{ tracks[item.track].display_title }}
              </p>
              <p class="text small track-artist">
                {{ tracks[item.track].artist.name }}
              </p>
              <p
                v-if="item.track.instrumental_version"
                class="text small"
              >
                <span
                  class="icon-static small info"
                  style="margin: -4px 0 -4px 0;"
                />
                Includes instrumental version
              </p>
              <span class="tag is-small is-hidden-tablet">Custom license</span>
            </div>
            <div class="column is-hidden-mobile">
              <h3 class="title is-4">
                Custom license
              </h3>
              <p>{{ item.description }}</p>
            </div>
            <div class="column is-narrow">
              {{ item.unit_amount|formattedDbAmount(currencySymbol) }}
            </div>
          </div>
          <div class="total">
            <h3 class="title is-3 is-pulled-left">
              Total
            </h3>
            <span class="is-pulled-right text caption">{{ order.amount_due|formattedDbAmount(currencySymbol) }}</span>
          </div>
        </div>

        <div
          v-if="busy"
          class="columns"
        >
          <div class="column is-12 has-text-centered">
            <br>
            <span
              class="loader xl"
              style="display: inline-block; width: 3em; height: 3em;"
            />
          </div>
        </div>

        <div class="footer">
          <router-link
            :disabled="busy"
            :to="{ name: 'custom-order-checkout', params: { orderId } }"
            class="button is-primary is-large is-pulled-right"
          >
            Go to checkout
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import orderClient from '@/api/orders.js'
import trackClient from '@/api/tracks.js'

export default {
  name: 'CustomOrderCart',

  props: {
    orderId: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      busy: true,
      order: null,
      tracks: {}
    }
  },

  computed: {
    user: function () {
      return this.$store.getters['user/currentUser']
    },

    fullName: function () {
      return this.$store.getters['user/fullName']
    },

    loaded: function () {
      return this.order !== null && this.order.items.length === Object.keys(this.tracks).length
    },

    currencySymbol: function () {
      if (this.order !== null) {
        return this.order.currency.symbol
      }
      return ''
    }
  },

  created () {
    const vm = this

    orderClient.retrieve(vm.orderId)
      .then((response) => {
        if (response.data.status === 'open') {
          vm.order = response.data

          const trackRetrieves = []
          vm.order.items.forEach(function (item) {
            trackRetrieves.push(
              trackClient.retrieve(item.track).then(response => {
                vm.$set(vm.tracks, item.track, response.data)
              })
            )
          })
          Promise.all(trackRetrieves).then(() => {
            vm.busy = false
          })
        }
      })
      .catch((error) => {
        if (error.response.status === 404) {
          vm.$router.push({ name: 'not-found' })
        }
      })
  },

  metaInfo: {
    title: 'Cart'
  }
}

</script>

<style scoped lang="scss">
  .total {
    clear: both;
    overflow: hidden;
  }
</style>
